/**
 * AdminOwner.jsx is mounted by App.js at /admin/owner/*. It renders the
 * OwnerLayout shell (sidebar + topbar + auth check) and nested sub-routes
 * for Phase A, E, F, and G surfaces.
 */
import { Route, Routes } from "react-router-dom";
import OwnerLayout from "@/components/owner/OwnerLayout";
import OwnerOverview from "@/components/owner/OwnerOverview";
import LibraryView from "@/components/owner/LibraryView";
import AgentsView from "@/components/owner/AgentsView";
import VaultView from "@/components/owner/VaultView";
import AuditView from "@/components/owner/AuditView";
import PipelineView from "@/components/owner/PipelineView";
import ProjectsView from "@/components/owner/ProjectsView";
import AnalyticsView from "@/components/owner/AnalyticsView";
import SettingsView from "@/components/owner/SettingsView";
import PlansView from "@/components/owner/PlansView";
import MembersView from "@/components/owner/MembersView";
import DispatchesView from "@/components/owner/DispatchesView";
import AttachView from "@/components/owner/AttachView";
import OutboundView from "@/components/owner/OutboundView";
import TemplatesView from "@/components/owner/TemplatesView";
import SequencesView from "@/components/owner/SequencesView";
import LeadsView from "@/components/owner/LeadsView";
import ProspectsView from "@/components/owner/ProspectsView";
import WaitlistView from "@/components/owner/WaitlistView";
import CampaignMetricsView from "@/components/owner/CampaignMetricsView";
import ActivityView from "@/components/owner/ActivityView";
import SwarmConsole from "@/components/owner/SwarmConsole";
import CalendarView from "@/components/owner/CalendarView";
import HandoffView from "@/components/owner/HandoffView";

export default function AdminOwner() {
  return (
    <Routes>
      <Route element={<OwnerLayout />}>
        <Route index element={<OwnerOverview />} />
        <Route path="library" element={<LibraryView />} />
        <Route path="agents" element={<AgentsView />} />
        <Route path="vault" element={<VaultView />} />
        <Route path="audit" element={<AuditView />} />
        <Route path="pipeline" element={<PipelineView />} />
        <Route path="projects" element={<ProjectsView />} />
        <Route path="analytics" element={<AnalyticsView />} />
        <Route path="settings" element={<SettingsView />} />
        <Route path="plans" element={<PlansView />} />
        <Route path="members" element={<MembersView />} />
        <Route path="dispatches" element={<DispatchesView />} />
        <Route path="attach" element={<AttachView />} />
        <Route path="outbound" element={<OutboundView />} />
        <Route path="templates" element={<TemplatesView />} />
        <Route path="sequences" element={<SequencesView />} />
        <Route path="leads" element={<LeadsView />} />
        <Route path="prospects" element={<ProspectsView />} />
        <Route path="waitlist" element={<WaitlistView />} />
        <Route path="metrics" element={<CampaignMetricsView />} />
        <Route path="activity" element={<ActivityView />} />
        <Route path="swarm" element={<SwarmConsole />} />
        <Route path="calendar" element={<CalendarView />} />
        <Route path="handoff" element={<HandoffView />} />
      </Route>
    </Routes>
  );
}
